import { ButtonVariant } from '@vodafoneziggo/sandwich/components/button';
import { Button } from 'components/Button';
import { Col, Row } from 'components/Grid';
import { InlineAlert } from 'components/InlineAlert';
import { useFeature } from 'context/feature/feature.context';
import { FEATURES } from 'models/features.model';
import React, { useEffect } from 'react';
import { ContentUtil } from 'utils/content';
import { webviewMessage } from 'utils/webview-message';

import { content } from './payment-arrangement.content';
import * as S from './payment-arrangement.styles';

const contentUtil = new ContentUtil({ content, componentName: 'PaymentArrangementFinished' });

export const PaymentArrangementFinished = () => {
  const [createPASuccess, setCreatePASuccess] = React.useState(false);
  const isPaymentArrangementWebviewEnabled = useFeature(FEATURES.PAYMENT_ARRANGEMENT_WEBVIEW_ENABLED);

  if (!isPaymentArrangementWebviewEnabled) return null;

  useEffect(() => {
    if (createPASuccess) {
      webviewMessage.postPaymentArrangementCreated();
    }
  }, [createPASuccess]);

  if (createPASuccess) {
    return (
      <Row>
        <Col l={9} data-testid="payment-arrangement-create-success">
          <S.PaymentArrangementCard>
            <S.Title>Success</S.Title>
            <InlineAlert type="success" testid="create-payment-arrangement-succeed">
              {contentUtil.translateToString(`finishPA.successTitle`)}
            </InlineAlert>
          </S.PaymentArrangementCard>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col l={9} data-testid="payment-arrangement-create-success">
        <Button buttonVariant={ButtonVariant.DARK} onClick={() => setCreatePASuccess(true)}>
          {contentUtil.translateToString(`finishPA.finishButtonTitle`)}
        </Button>
      </Col>
    </Row>
  );
};
